import { render, staticRenderFns } from "./goodsAgent.vue?vue&type=template&id=c45b8854&scoped=true&"
import script from "./goodsAgent.vue?vue&type=script&lang=js&"
export * from "./goodsAgent.vue?vue&type=script&lang=js&"
import style0 from "./goodsAgent.vue?vue&type=style&index=0&id=c45b8854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c45b8854",
  null
  
)

export default component.exports